// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_ACTUALIZAR_PERITAJES,
} from './constants';
import { getEndpoint } from '../../common/backend/endpoints'
import axios from 'axios'

export function actualizarPeritajes() {
  return (dispatch, getState) => {

    const { presupuestador = {} } = getState()

    const endPointPeritador = getEndpoint('PERITADOR')

    // Funcion para retornar datos del auto en el state
    const returnCar = (car, error) => {
      return {
        id: car.id || '',
        quotation_id: car.quotation_id,
        original_price: car.original_price,
        final_take_price: car.final_take_price,
        take_improvement_amount: car.take_improvement_amount,
        oldValue: car.precio,
        peritado: car.peritado,
        year: car.year,
        brand: car.brand,
        model: car.model,
        version: car.version,
        versionId: car.version_id || car.versionId,
        patente: car.patente,
        km: car.km,
        valid: true,
        pending: false,
        error: error
      }
    }

    // Funcion para obtener peritaje
    async function getPeritaje(car) {
      const queryPeritaje = {
        where: {
          servicePatent: car.patente
        },
        order: 'serviceDate DESC',
      }
      let queryPeritajeQuotes = {
        where: {
          requestsId: car.quotation_id,
        },
        include: "verification",
      }
      let returnedCar = {}
      const peritaje = await axios((`${endPointPeritador}/requests?filter=${JSON.stringify(queryPeritaje)}`))
      if(peritaje.status === 200){
        if(peritaje.data.length > 0){
          let cambio = false
          peritaje.data.forEach(perit=>{
            if(perit.statusId === "6" || perit.statusId === 6){
              cambio = true
              queryPeritajeQuotes.where.requestsId = perit.id
            }
          })
          if(cambio){
            // Consulto los datos del peritaje
            const peritajeQuote = await axios(`${endPointPeritador}/verifiedQuotes?filter=${JSON.stringify(queryPeritajeQuotes)}`)
            if(peritajeQuote.status === 200){
              if(peritajeQuote.data.length > 0){
                const final_take_price = Number(car.assesed) === 6 && Number(peritajeQuote.data[0].verification.statusId) === 6 ?
                car.final_take_price : car.appraisal
                returnedCar = {
                  ...car,
                  quotation_id: peritajeQuote.data[0].requestsId,
                  year: peritajeQuote.data[0].verification.vehicle.year.label,
                  brand: peritajeQuote.data[0].verification.vehicle.brand.label,
                  model: peritajeQuote.data[0].verification.vehicle.model.label,
                  version: peritajeQuote.data[0].verification.vehicle.version.label,
                  versionId: peritajeQuote.data[0].verification.vehicle.version.value,
                  patente: car.patente,
                  km: peritajeQuote.data[0].verification.kilometraje,
                  peritado: peritajeQuote.data[0].verification.statusId,
                  pending: false,
                  error: null,
                  final_take_price,
                  appraisal: peritajeQuote.data[0].appraisal,
                }
              } else {
                returnedCar = returnCar(car, "Error al consultar el peritaje")
              }
            } else {
              returnedCar = returnCar(car, "Fallo la consulta al peritador")
            }
          } else {
            returnedCar = returnCar(car, null)
          }
        } else {
          // Si el auto ya no está en peritaje, y en ningun otro estado
          returnedCar = returnCar(car, null)
        }
      } else {
        returnedCar = returnCar(car, "Fallo la consulta al peritador")
      }
      return returnedCar
    }

    // Recorro los autos usados
    if(presupuestador.entregaUsados){
      if(presupuestador.entregaUsados.length > 0){
        presupuestador.entregaUsados.forEach(car=>{
            getPeritaje(car)
              .then(res=>{
                dispatch({
                  type: PRESUPUESTADOR_ACTUALIZAR_PERITAJES,
                  data: res
                })
              })
        })
      }
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_ACTUALIZAR_PERITAJES:
      return {
        ...state,
        entregaUsados: state.entregaUsados.map(usado=>{
          if(action.data.patente){
            if (usado.patente === action.data.patente) {
              return action.data
            } else {
              return usado
            }
          } else {
            return usado
          }
        })
      };

    default:
      return state;
  }
}
